export default "__VITE_ASSET__D1ZSYVsP__"